import moment from 'moment';
import React from 'react';

export default function Table({ bets }) {
  let betsArray = [];
  if (bets) {
    betsArray = Object.values(bets);
  }
  return (
    <div className="w-full overflow-x-scroll md:overflow-x-hidden">
      <table className="w-full">
        {/* table header */}
        <thead className="w-full">
          <tr className="w-full flex justify-between items-center p-3 rounded-tr-lg bg-table">
            <th className="w-[6rem] lg:basis-2/12 lg:px-4 text-sm text-table-text text-start font-DMSans">Date</th>
            <th className="w-[5rem] lg:basis-1/12 lg:px-4 text-sm text-table-text text-start font-DMSans">Type</th>
            <th className=" w-[9rem] lg:basis-3/12 lg:px-4 text-sm text-table-text text-start font-DMSans">
              <span className="">Description</span>
            </th>
            <th className="w-[3rem] lg:basis-1/12   lg:px-4 text-sm text-table-text text-start font-DMSans ">
              Quantity
            </th>
            <th className="w-[5rem] lg:basis-1/12   lg:px-4 text-sm text-table-text text-start font-DMSans ">
              Allocation
            </th>
            </tr>
        </thead>
        {/* table body */}
        <tbody className="w-full">
          {betsArray?.map((bet, index) => {
            const {
              Allocation,
              Date: date,
              Dime,
              Game,
              League,
              Link,
              TimestampUTC,
              'Pick of the day': pick,
                          } = bet;
            return (
              <tr
                className="w-full flex justify-between items-center px-3  p-2 rounded-tr-lg bg-primary hover:bg-table"
                key={index}
              >
                <td className="w-[6rem] lg:basis-2/12 lg:px-4 text-sm text-table-text text-start font-DMSans ">
                  {date?.split('.').join('/')} {moment(new Date(TimestampUTC * 1000)).format('LT')}
                </td>
                <td className="w-[5rem] lg:basis-1/12  lg:px-4 text-sm text-table-text text-start font-DMSans">
                  {League}
                </td>
                <td className="flex flex-col justify-start w-[9rem] lg:basis-3/12 lg:px-4 ">
                  <a
                    href={Link}
                    target="_blank"
                    rel="noreferrer"
                    className=" text-sm text-white font-bold hover:text-green-500 transition-colors text-start font-DMSans"
                  >
                    {pick}
                  </a>
                  <p className="text-table-text text-xs">{Game}</p>
                </td>
                <td className="w-[3rem] lg:basis-1/12  lg:px-4 text-sm text-table-text text-start font-DMSans">
                  {Dime}
                </td>
                <td className="w-[5rem] lg:basis-1/12 lg:px-4 text-sm text-table-text text-start font-DMSans">
                  {' '}
                  ${Allocation}
                </td>
                </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
